"use client";

import { c as _c } from "react/compiler-runtime";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface MemesQuickVoteDropHeaderProps {
  readonly drop: ExtendedDrop;
}
export default function MemesQuickVoteDropHeader(t0) {
  const $ = _c(18);
  const {
    drop
  } = t0;
  const authorLabel = drop.author.handle ?? drop.author.primary_address;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== authorLabel) {
    t2 = <span className="tw-truncate tw-text-md tw-font-bold tw-leading-none tw-tracking-tight tw-text-white">{authorLabel}</span>;
    $[2] = authorLabel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-text-xs tw-font-medium tw-leading-none">•</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.created_at) {
    t4 = <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-iron-500 [&_p]:tw-mb-0">{t3}<WaveDropTime timestamp={drop.created_at} /></span>;
    $[5] = drop.created_at;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="tw-mb-2.5 tw-flex tw-items-center tw-gap-1.5">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.wave.name) {
    t6 = <p className="tw-mb-0 tw-truncate tw-text-[9px] tw-font-semibold tw-uppercase tw-leading-none tw-tracking-widest tw-text-iron-500">{drop.wave.name}</p>;
    $[10] = drop.wave.name;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-min-w-0 tw-flex-1">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-3">{t1}{t7}</div>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}